import { useCallback } from "react";
import "./style/capturePicture.scss";
import { useNavigate } from "react-router-dom";
import { useVisitorData } from "../../hooks/useVisitorData";
import { BackButton } from "../../components/ui/Button/backButton";
import { useStrings } from "../../hooks/useStrings";
import { PassportIcon, DriversLicenseIcon, StateIssuedIcon, OthersIcon } from "../../components/icons";

const CapturePicture = () => {
  const S = useStrings();
  const navigate = useNavigate();
  const {
    visitorinfo,
    orgTemplateIds,
    updateVisitorInfo,
    updateIdCaptureType,
  } = useVisitorData();

  const idTypes = S.CAPTURE_PICTURE.ID_TYPES;

  const handleIDCaptureType = useCallback(
    (id: string) => {
      if (visitorinfo) updateVisitorInfo({ ...visitorinfo, idType: id });
      updateIdCaptureType(id);
      navigate("/frontbackpicture");
    },
    [visitorinfo, updateVisitorInfo, updateIdCaptureType, navigate],
  );

  const getTheIcon = (id: string) => {
    switch (id) {
      case "DRIVING_LICENCE":
        return <DriversLicenseIcon />;
      case "STATE_ISSUED_ID":
        return <StateIssuedIcon />;
      case "PASSPORT":
        return <PassportIcon />;
      case "OTHERS":
        return <OthersIcon />;
      default:
        return <OthersIcon />;
    }
  };

  const handleBack = useCallback(() => {
    const id = orgTemplateIds;
    if (id) navigate("/signdocument");
    else navigate("/visitorform");
  }, [orgTemplateIds, navigate]);

  return (
    <>
      <div className="main-screen" data-testid="capturePicture-div-main-screen">
        <div
          className="screen-outer"
          data-testid="capturePicture-div-screen-outer"
        >
          <div
            className="screen-header-fixed"
            data-testid="capturePicture-div-screen-header-fixed"
          >
            <div
              className="header-fixed-left"
              data-testid="capturePicture-div-header-fixed-left"
            >
              <BackButton
                dataTestId="capturePicture-backButton"
                onBack={handleBack}
              />
            </div>
          </div>

          <div
            className="screen-inner"
            data-testid="capturePicture-div-screen-inner"
          >
            <div
              className="screen-body"
              data-testid="capturePicture-div-screen-body"
            >
              <h5
                className="screen-title"
                data-testid="capturePicture-h5-screen-title"
              >
                {S.CAPTURE_PICTURE.TITLE}
              </h5>
              <p
                className="screen-subtitle"
                data-testid="capturePicture-p-screen-subtitle"
              >
                {S.CAPTURE_PICTURE.SUBTITLE}
              </p>

              <ul
                className="id-type-list"
                data-testid="capturePicture-ul-visitor-type-list"
              >
                {idTypes.map((item) => (
                  <li
                    key={item.value}
                    data-testid={`capturePicture-li-visitor-type-${item.value}`}
                  >
                    <button
                      type="button"
                      className="btn btn-type"
                      onClick={() => handleIDCaptureType(item.value)}
                      data-testid={`capturePicture-button-id-type-${item.value}`}
                    >
                      <span data-testid={`capturePicture-icon-id-type-${item.value}`}>
                        {getTheIcon(item.value)}
                      </span>
                      {item.label}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CapturePicture;
